import { DocumentsUpload, Label } from '@pay-com/components'
import { ErrorMessage } from 'components/ErrorMessage'
import { isProd } from 'consts'
import {
  TaskDetail,
  TaskField,
  useCreateDocumentUploadTokenQuery
} from 'generated/graphql'

type TaskDocumentsFieldProps = {
  field: TaskField
  taskDetails?: TaskDetail
  value?: unknown
  onChange?: (value: unknown) => void
  error?: string
}

export const TaskDocumentsField = ({
  field,
  taskDetails,
  value,
  onChange,
  error
}: TaskDocumentsFieldProps) => {
  const { data: documentUpload } = useCreateDocumentUploadTokenQuery({
    pollInterval: 30 * 60 * 1000,
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache'
  })

  return (
    <>
      <Label label={field.label} className="-mb-2" />
      <DocumentsUpload
        reference={`tasks:${taskDetails?.id}:${field.id}`}
        type="OTHER"
        title=""
        token={documentUpload?.documentUploadToken.token ?? ''}
        onSuccess={documentsIds =>
          onChange?.([
            ...new Set([...((value as string[]) || []), ...documentsIds])
          ])
        }
        onRemove={document =>
          onChange?.(
            ((value as string[]) || []).filter(id => id !== document.id)
          )
        }
        withProgressBar
        iframeBaseURL={`https://upload${isProd ? '' : '.dev'}.pay.com`}
        autoUpload
        maxSizeMB={10}
        accept="image/png, image/jpeg, application/pdf, video/quicktime, video/mp4, video/avi, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, video/webm"
        multiple
      />
      <ErrorMessage errorMessage={error} />
    </>
  )
}
